import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import Helpers from "../../../../utils/helpers";
import { wrap } from "module";
import TokenService from "../../../../services/autentication/token.service";

const GridPanel = (props: any) => {
  const getUser = TokenService.getUser();

  var navigate = useNavigate();
  const [gridDatas, setGridDatas] = useState<any[]>([]);
  const responsiveOptions = [
    {
      breakpoint: "1199px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "991px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  useEffect(() => {
    if (props && props.filteredItems && props.filteredItems.length > 0) {
      setGridDatas(props.filteredItems);
    }
  }, [props]);
  const DetailsOverlay = (data: any) => {
    const selectDaysDpDown = useRef<any>(null);
    return (
      <>
        {getUser?.superAdmin === true || getUser?.globalAdmin == true ? (
          <>
            {/* <i
              className="pi pi-ellipsis-v"
              style={{ fontSize: "1em", cursor: "pointer" }}
              onClick={(e) => selectDaysDpDown.current.toggle(e)}
            ></i> */}
            <OverlayPanel className="popup-block" ref={selectDaysDpDown}>
              
              <ul style={{}}>
                <li style={{}}>
                  <a
                    href="javascript:void(0);"
                    onClick={() => {
                      navigate(
                        `/aura-camera/operation-details/${data?.row?.siteID}/${data?.row?.createdOn}`
                      );
                    }}
                  >
                    Delete
                  </a>
                  <span className="material-symbols-outlined" style={{}}>
                    keyboard_arrow_right
                  </span>
                </li>
                <li style={{}}>
                  <a
                    href="javascript:void(0);"
                    onClick={() => {
                      navigate(
                        `/aura-camera/operation-details/${data?.row?.siteID}/${data?.row?.createdOn}`
                      );
                    }}
                  >
                    Edit
                  </a>
                  <span className="material-symbols-outlined" style={{}}>
                    keyboard_arrow_right
                  </span>
                </li>
              </ul>
            </OverlayPanel>
          </>
        ) : (
          ""
        )}
      </>
    );
  };
  const productTemplate = (gridData: any) => {
    return (
      <>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="card panel-box">
            <div className="card-header">
              <h6>{gridData.siteName}</h6>
              <div className="dropdown">
                <DetailsOverlay row={gridData} />
              </div>
            </div>
            <div className="card-body">
              <ol>
                <li>
                  <div className="list-title">Company</div>
                  <div className="list-value">{gridData?.company}</div>
                </li>
                <li>
                  <div className="list-title">Name</div>
                  <div className="list-value">{gridData?.name}</div>
                </li>
                <li>
                  <div className="list-title">Email</div>
                  <div className="list-value">{gridData?.email}</div>
                </li>
                <li>
                  <div className="list-title">Contact number</div>
                  <div className="list-value">{gridData?.contact_number}</div>
                </li>

                <li>
                  <div className="list-title">Initial training date</div>
                  <div className="list-value">
                  {Helpers.convertUTCtoMMDDYYYY(gridData.initialTrainingDate)}
                  </div>
                </li>

                <li>
                  <div className="list-title">Last training date</div>
                  <div className="list-value">
                    {Helpers.convertUTCtoMMDDYYYY(gridData.lastTrainingDate)}
                  
                  </div>
                </li>

                <li>
                  <div className="list-title">Refresher training</div>
                  <div className="list-value">
                    {gridData?.ogI_Refreshing_Time}
                  </div>
                </li>

                <li>
                  <div className="list-title">Total operating hours</div>
                  <div className="list-value">
                    {gridData?.total_Training_Hours}
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <Carousel
        value={gridDatas}
        numVisible={3}
        numScroll={1}
        responsiveOptions={responsiveOptions}
        itemTemplate={productTemplate}
      />
    </>
  );
};

export default GridPanel;
